import { useState, useEffect } from 'react';

// Breakpoint padronizado mobile-first (< 768px = smartphone e tablet portrait em fluxo mobile)
const MOBILE_QUERY = '(max-width: 767px)';

export function useIsMobile() {
    const [mobile, setMobile] = useState(() => 
        typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY).matches : false
    );

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_QUERY);
        const onChange = () => setMobile(mq.matches);
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, []);

    return mobile;
}
